<template>
  <div>
    <div class="pad20 pay" v-if="detail.paymentRecordBoList && detail.paymentRecordBoList.length > 1">
      <div class="flex">
        <div class="gray3 f16 fb">支付信息</div>
        <div class="flex-auto text-right mar15-b">
          已支付<span class="pad5-lr red">{{ detail.paymentRecordBoList ? detail.paymentRecordBoList.length : 0 }}</span
          >笔， 共计<span class="pad5-lr red">¥ {{ detail.pmoney }}</span
          >，剩余待支付金额<span class="pad5-lr red">¥ {{ (detail.fmoney - detail.pmoney).toFixed(2) }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="w270" v-for="payment in detail.paymentRecordBoList" :key="payment.paymentTime">
          <div>¥ {{ payment.pmoney }}</div>
          <div class="f12 gray6">{{ payment.paymentTime }}</div>
        </div>
      </div>
    </div>
    <div class="pad20 flex text-right">
      <div class="text-right gray6 flex-auto mar15-r">
        <div class="mar5-b" v-if="detail.omoney > 0">货品总额：</div>
        <div class="mar5-b" v-if="detail.smoney > 0">价格优惠：</div>
        <div class="mar5-b" v-if="detail.couponMoney > 0">优惠券抵扣：</div>
        <div class="mar5-b" v-if="detail.cashMoney > 0">现金券抵扣：</div>
        <div class="mar5-b" v-if="detail.platformMoney > 0">平台券抵扣：</div>
        <div class="mar5-b" v-for="zk in detail.zkRecord" :key="zk.payTool">
          <div v-if="zk.payTool == 'SC_POINTS' && zk.amount > 0">积分抵扣：</div>
          <div v-if="zk.payTool == 'BOUNTY_MONEY' && zk.amount > 0">奖励金抵扣：</div>
        </div>
        <div class="mar5-b">运费：</div>
        <div class="mar5-b" v-if="detail.freightPromotionAmount && Number(detail.freightPromotionAmount) > 0">新用户首单运费优惠：</div>
        <div v-if="detail.differenceMoney > 0">返还金额：</div>
      </div>
      <div>
        <div class="mar5-b" v-if="detail.omoney > 0">¥{{ detail.omoney ? parseFloat(detail.omoney.toString()).toFixed(2) : "0.00" }}</div>
        <div class="mar5-b red" v-if="detail.smoney > 0">- ¥{{ detail.smoney ? parseFloat(detail.smoney.toString()).toFixed(2) : "0.00" }}</div>
        <div class="mar5-b red" v-if="detail.couponMoney > 0">- ¥{{ detail.couponMoney ? parseFloat(detail.couponMoney.toString()).toFixed(2) : "0.00" }}</div>
        <div class="mar5-b red" v-if="detail.cashMoney > 0">- ¥{{ detail.cashMoney ? parseFloat(detail.cashMoney.toString()).toFixed(2) : "0.00" }}</div>
        <div class="mar5-b red" v-if="detail.platformMoney > 0">
          - ¥{{ detail.platformMoney ? parseFloat(detail.platformMoney.toString()).toFixed(2) : "0.00" }}
        </div>
        <div class="mar5-b red" v-for="zk in detail.zkRecord" :key="zk.payTool">
          <div v-if="zk.payTool == 'SC_POINTS' && zk.amount > 0">- ¥{{ zk.amount ? parseFloat(zk.amount.toString()).toFixed(2) : "0.00" }}</div>
          <div v-if="zk.payTool == 'BOUNTY_MONEY' && zk.amount > 0">- ¥{{ zk.amount ? parseFloat(zk.amount.toString()).toFixed(2) : "0.00" }}</div>
        </div>
        <div class="mar5-b">+ ¥{{ detail.freightMoney ? parseFloat(detail.freightMoney.toString()).toFixed(2) : "0.00" }}</div>
        <div class="mar5-b" v-if="detail.freightPromotionAmount && Number(detail.freightPromotionAmount) > 0">
          - ¥{{ detail.freightPromotionAmount ? parseFloat(detail.freightPromotionAmount.toString()).toFixed(2) : "0.00" }}
        </div>
        <div class="red" v-if="detail.differenceMoney > 0">
          ¥{{ detail.differenceMoney ? parseFloat(detail.differenceMoney.toString()).toFixed(2) : "0.00" }}
        </div>
      </div>
    </div>
    <div class="pad20 mar15-t flex items-baseline justify-end pad5-t pad5-b total">
      <div class="gray6 mar10-r">应付款</div>
      <div class="red mar5-r">¥</div>
      <div class="red f28">{{ detail.fmoney ? detail.fmoney.toString().split(".")[0] : detail.fmoney || "0.00" }}</div>
      <div class="red">.{{ detail.fmoney && detail.fmoney.toString().split(".").length > 1 ? detail.fmoney.toFixed(2).split(".")[1] : "00" }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../order/detail/detail.scss";
</style>

<script>
export default {
  name: "order_pay_info_dtl",
  props: {
    detail: {},
  },
};
</script>
